var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "Footer_socialIcon__FxYFX",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55 22.5c9.05 0 14-7.5 14-14v-.64A10 10 0 0024 5.3c-.88.39-1.83.65-2.83.77a4.94 4.94 0 002.17-2.72c-.95.56-2 .98-3.13 1.2a4.92 4.92 0 00-8.39 4.49C7.72 8.83 4.1 6.88 1.67 3.9a4.9 4.9 0 001.52 6.57 4.9 4.9 0 01-2.23-.61v.06c0 2.38 1.7 4.38 3.95 4.83a4.94 4.94 0 01-2.22.08 4.93 4.93 0 004.6 3.42A9.88 9.88 0 010 20.29a13.94 13.94 0 007.55 2.21z",
    fill: "#db2b27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bd7234f34f15438364865f582f46026e.svg";
export { ForwardRef as ReactComponent };